module.exports = __webpack_public_path__ + "static/img/tel_2.3db5552.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/tel_2.gif
// module id = 7KXw
// module chunks = 1